import { Tbl_pianiList } from './tbl_pianiList';
import { Tbl_pianiEdit } from './tbl_pianiEdit';
import { Tbl_pianiShow } from './tbl_pianiShow';
import { Tbl_pianiCreate } from './tbl_pianiCreate';
import CategoryIcon from '@material-ui/icons/Category';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  list: Tbl_pianiList,
  edit: Tbl_pianiEdit,
  show: Tbl_pianiShow,
  create: Tbl_pianiCreate,
  icon: CategoryIcon
};
